<template>
    <div>
        <sweet-modal blocking title="Purchase Request" ref="purchaseProjectTaskRequest" class="modal" v-on:close="closePurchaseProjectTaskRequest">
            <el-form :model="form" size="mini" label-width="115px" ref="form" status-icon :rules="rules"  class="demo-ruleForm">
                <!--<div style="display:flex; justify-content: center;">-->
                    <!--<h2>Purchase Request</h2>-->
                <!--</div>-->
                <!--{{form.items}}-->
                <!-- ROW FOR CREATE Start -->
                <el-row v-if="action === 'create'" :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="projectId" :label="labelName">
                            <el-select style="width:100%" no-data-text="no date" v-model="form.projectId" placeholder="Project">
                                <el-option
                                        v-for="item in projectList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="handleSelectProject(item)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="taskId" label="Task">
                            <el-select clearable :disabled="disabledInputs" style="width:100%" no-data-text="no date" v-model="form.taskId" placeholder="Task">
                                <el-option
                                        v-for="item in taskList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="handleSelectTask(item)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- ROW FOR CREATE End -->

                <!-- ROW FOR Edit Start -->
                <el-row v-if="action === 'manageProject' || action === 'editProject'" :span="24" :gutter="20">
                        <el-form-item prop="projectId" :label="labelName">
                            <el-select style="width:100%" no-data-text="no date" v-model="form.projectId" placeholder="Project">
                                <el-option
                                        v-for="item in projectList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                </el-row>
                <!-- ROW FOR Edit End -->

                <!-- ROW FOR Edit Start -->
                <el-row v-if="action === 'manageTask' || action === 'editTask'" :span="24" :gutter="20">
                    <el-form-item prop="taskId" label="Task">
                        <el-select :disabled="disabledInputs" style="width:100%" no-data-text="no date" v-model="form.taskId" placeholder="Task">
                            <el-option
                                    v-for="item in taskList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <!-- ROW FOR Edit End -->

                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="vendorId" label="Vendor">
                            <el-select :disabled="disabledInputs" style="width:100%" no-data-text="no date" v-model="form.vendorId" placeholder="Task Type">
                                <el-option
                                        v-for="item in vendorList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="handleSelectVendor(item)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="date" label="Order Date">
                            <el-date-picker
                                    :disabled="disabledInputs"
                                    v-model="form.date"
                                    format="d MMM yy"
                                    value-format="timestamp"
                                    type="date"
                                    placeholder="Pick a day">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Current Credit">
                            {{formatPrice(form.vendorCredit)}}
                        </el-form-item>
                        <el-form-item label="Vendor Currency">
                            {{form.vendorCurrency}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Exchange Rate" prop="exchageRate">
                            <el-input :disabled="disabledInputs" type="number" placeholder="Exchange Rate" v-model="form.exchageRate"></el-input>
                        </el-form-item>
                        <el-form-item>
                            {{form.exchageRate}} USD = 1 {{form.vendorCurrency}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Reference" prop="reference">
                            <el-input :disabled="disabledInputs" placeholder="Reference" v-model="form.reference"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Deliver to:" prop="deliverTo">
                            <el-input :disabled="disabledInputs" placeholder="Deliver to" v-model="form.deliverTo"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24">
                    <el-form-item label="Description" prop="description">
                        <el-input :disabled="disabledInputs" type="textarea" v-model="form.description"></el-input>
                    </el-form-item>
                </el-row>
                <el-row :span="24">
                    <el-form-item  label="Select Items" prop="itemsId">
                        <el-select :disabled="disabledInputs" style="width:100%" v-model="form.itemsId" multiple filterable @remove-tag="removeTag" placeholder="Items">
                            <el-option
                                    v-for="item in selectedVendor.items"
                                    :key="item.id"
                                    :label="item.number || item.code + '/' +  item.name"
                                    :value="item.id"
                                    @click.native="setItemToRequest(item)">
                                <span style="float: left">No. {{ item.number }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <!--{{form.ifTax}}-->
                <el-row :span="24">
                    <el-form-item prop="ifTax">
                        <el-radio-group :disabled="disabledInputs" v-model="form.ifTax" style="display:flex;">
                            <el-radio label="Tax Exclusive"></el-radio>
                            <el-radio label="Tax Inclusive"></el-radio>
                        </el-radio-group>
                        <el-form-item prop="isWth">
                            <el-checkbox :disabled="disabledInputs" @change="countModalFull()" v-model="form.isWth" label="Apply WHTax"></el-checkbox>
                        </el-form-item>
                    </el-form-item>
                </el-row>
                <!--TABLE START -->
                Items
                <el-table
                        size="mini"
                        border
                        :data="form.items"
                        style="width: 100%"
                        @cell-click="cellClick">
                    <el-table-column
                            label="No."
                            width="80">
                        <template slot-scope="scope">
                            {{scope.row.code}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Name"
                            width="100">
                        <template slot-scope="scope">
                            {{scope.row.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Unit Price">
                        <template slot-scope="scope">
                            <el-form-item label-width="0"
                                          :prop="'items.' + scope.$index + '.amount'"
                                          :rules="{
                                          required: true, message: 'Field is required', trigger: 'blur'
                                          }">
                                <el-input :disabled="disabledInputs" @mouseleave.native="countModalFull()" @change="countModalFull()" type="number" v-model="scope.row.amount" size="mini"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Qty"
                            width="80">
                        <template slot-scope="scope">
                            <el-form-item label-width="0"
                                          :prop="'items.' + scope.$index + '.qty'"
                                          :rules="[
                                          {required: true, message: 'Field is required', trigger: 'blur'},
                                          { validator: checkNum, trigger: 'blur' }
                                          ]">
                                <el-input :disabled="disabledInputs" v-model="scope.row.qty" @mouseleave.native="countModalFull()" @change="countModalFull()" type="number"  size="mini"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="VAT exclusive">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.vatExclusive = countVatExclusive(Number(scope.row.amount), Number(scope.row.qty), scope.row.tax, form.ifTax))}}
                            <!--{{formatPrice(vatExclusive)}}-->
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Tax">
                        <template slot-scope="scope">
                            <el-form-item label-width="0"
                                          :prop="'items.' + scope.$index + '.taxId'"
                                          :rules="{
                                              required: true, message: 'Field is required', trigger: 'blur'
                                              }">
                                <el-select :disabled="disabledInputs" type="number" v-model="scope.row.taxId" size="mini" placeholder="Tax">
                                    <el-option
                                            v-for="item in taxList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                            @click.native="scope.row.tax = item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Unit"
                            width="80">
                        <template slot-scope="scope">
                            {{scope.row.unit.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="WHTax"
                            width="100px">
                        <template slot-scope="scope">
                            <div v-if="form.isWth">
                                {{scope.row.itemWhTaxName}}
                            </div>
                            <div v-else>
                                N/A
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Required Delivery date">
                        <template slot-scope="scope">
                            <el-form-item label-width="0px"
                                          :prop="'items.' + scope.$index + '.date'"
                                          :rules="{
                                          required: true, message: 'Field is required', trigger: 'blur'
                                          }">
                                <el-date-picker
                                        :disabled="disabledInputs"
                                        v-model="scope.row.date"
                                        format="d MMM yy"
                                        value-format="timestamp"
                                        type="date"
                                        placeholder="Pick a day">
                                </el-date-picker>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Total">
                        <template slot-scope="scope">
                            {{formatPrice(scope.row.total = countTotalAmount(scope.row.amount, scope.row.qty, scope.row.tax, form.ifTax))}}
                        </template>
                    </el-table-column>
                </el-table>

                <!--TABLE END -->
                <el-row :span="24" style="display:flex; justify-content: flex-end">
                    <el-col :span="12">
                        <el-form-item style="margin-bottom:0; margin-top:20px;">
                            <el-checkbox :disabled="disabledInputs" v-model="form.allowPartialDeliveries" label="Allow Partial Deliveries"></el-checkbox>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            <el-checkbox :disabled="disabledInputs" v-model="form.sendInventoryWithBill" label="Send Inventory with Bill"></el-checkbox>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            <el-checkbox :disabled="disabledInputs" v-model="form.sendInventoryWithoutBill" label="Send Inventory without Bill"></el-checkbox>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                        Internal
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            <el-checkbox :disabled="disabledInputs" v-model="form.receiveReportRequired" label="Receive Report Required"></el-checkbox>
                        </el-form-item>
                        <el-form-item style="margin-bottom:0;">
                            <el-checkbox :disabled="disabledInputs" v-model="form.inspectionReportRequired" label="Inspection Report Required"></el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <div class="bill">
                            <h4 v-if="form.ifTax === 'Tax Exclusive'"><span>Subtotal</span><span> {{formatPrice(form.subTotal = countSubtotal(form.items))}} </span></h4>
                            <h4 v-if="form.ifTax === 'Tax Exclusive'"><span>+ Tax of</span><span>{{formatPrice(form.taxOf = countTaxOf(form.items))}}</span></h4>
                            <h4 v-if="form.ifTax === 'Tax Inclusive'"><span>Includes Tax of</span><span>{{ formatPrice(form.includesTaxOf = countIncludesTaxOf(form.items))}} </span></h4>
                            <h4><span>Total Amount</span><span> {{formatPrice(form.totalAmount = countSumTotalAmount(form.items))}} </span> </h4>
                            <h4 v-if="form.isWth"><span>WHTax Amount</span><span>{{formatPrice(form.whtTaxAmount = countWhtTaxAmount(form.items)) }}</span></h4>
                            <el-divider></el-divider>
                            <div class="payment-to-vendor">
                                <h3><span>Payment to Vendor</span><span>{{formatPrice(form.paymentToVendor = countPaymentToVendor(form.totalAmount, form.whtTaxAmount, form.isWth))}}</span></h3>
                            </div>
                        </div>
                    </el-col>
                </el-row>

                <el-form-item v-if="action === 'create'" style="display: flex; justify-content: flex-end; margin-top:20px;">
                    <el-button @click="purchaseSubmit('form')" class="modal__btn" type="primary" plain size="medium">Add Request</el-button>
                </el-form-item>
                <el-form-item v-if="action === 'manageProject' || action === 'manageTask'" style="display: flex; justify-content: flex-end; margin-top:20px;">
                    <el-button @click="purchaseApprove('form', activePurchaseId)" class="modal__btn" type="primary" plain size="medium">Approve</el-button>
                </el-form-item>
                <el-form-item v-if="action === 'manageProject' || action === 'manageTask'" style="display: flex; justify-content: flex-end; margin-top:20px;">
                    <el-button @click="$refs.rejectConfirm.open()"  class="modal__btn" type="primary" plain size="medium">Reject</el-button>
                </el-form-item>
                <el-form-item v-if="action === 'editProject' || action === 'editTask'" style="display: flex; justify-content: flex-end; margin-top:20px;">
                    <el-button @click="purchaseEdit('form', activePurchaseId)" class="modal__btn" type="primary" plain size="medium">Edit</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <!--REJECT CONFIRM MODAL-->
        <sweet-modal v-on:close="rejectConfirmClose"  blocking class="nested-confirm" ref="rejectConfirm">
            <h1 class="modal__title" style="color:black; text-align:left;">Reason</h1>
            <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="Description"
                    v-model="description">
            </el-input>
            <el-row :span="24" class="modal__bottom">
                <el-button
                        size="mini"
                        type="danger"
                        plain
                        @click="purchaseReject('form', activePurchaseId)">Reject</el-button>
            </el-row>
        </sweet-modal>
        <!--REJECT CONFIRM MODAL-->


    </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';


  export default {
    name: "purchaseProjectTaskRequestModal",
    components:{
      SweetModal,

    },
    props: ['selectedRow'],
    data() {
      return{
        action: 'create',
        labelName: 'Project',
        state: 'project',
        activePurchaseId: '',
        disabledInputs: true,
        projectList: [],
        taskList: [],
        vendorList:[],
        itemsList:[],
        taxList: [],
        selectedVendor: {},
        selectedProject: {},
        selectedTask: {},
        // reject description
        description: '',
        form:{
          projectId: '',
          taskId: '',
          vendorId: '',
          date: null,
          vendorCurrency: "GBP",
          vendorCredit: '0',
          exchageRate: null,
          reference: null,
          deliverTo: null,
          description: null,
          itemsId:[],
          ifTax: 'Tax Exclusive',
          isWth: false,
          items:[],
          //bill
          subTotal: '0',
          taxOf: '0',
          totalAmount:'0',
          includesTaxOf: '0',
          whtTaxAmount: '0',
          paymentToVendor: '0',
          //checkboxes
          allowPartialDeliveries: false,
          sendInventoryWithBill: false,
          sendInventoryWithoutBill: false,
          receiveReportRequired:false,
          inspectionReportRequired:false
        },
        rules:{
          projectId: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ],
          vendorId: [
            { required: true, message: 'Please input Vendor name', trigger: 'blur' }
          ],
          reference: [
            { required: true, message: 'Please pick a reference', trigger: 'blur' }
          ],
          itemsId:[
            { required: true, message: 'Please pick a reference', trigger: 'blur' }
          ]
        },
      }
    },
    methods:{
      // open modal purchases
      async openModalFromPurchase(state){
        try {
          const urlParts = this.buildUrl(state)
          this.labelName = urlParts.labelName
          this.state = state
          //Get project list
          this.projectList = await this.getProjectList(urlParts.routeName)
          this.$refs.purchaseProjectTaskRequest.open()
        }catch (err){
          console.log(err)
        }
      },
      // open modal purchases
      async openModalEditManager(companyId, projectId, projectTaskId, purchaseId, state, manager){
        this.activePurchaseId = purchaseId
        this.disabledInputs = false

        console.log('companyId, purchaseId, state, manager', companyId, 'projectId', projectId, 'projectTaskId', projectTaskId, purchaseId, state, manager)
        try {
          const urlParts = this.buildUrl(state)
          this.labelName = urlParts.labelName
          this.state = state

          //Get project list
          // this.projectList = await this.getProjectList(urlParts.routeName)

          //Get task list
          if(projectId){
            this.action = 'manageProject'
            // this.taskList = await this.getTaskList(projectId)

            // Get directories if project
            await this.getDirectory(urlParts.stateProjectId, projectId)

            //Get purchase item if project
            await this.getPurchaseItem(state, purchaseId)
          }else{
            this.action = 'manageTask'
            // Get directories if task
            await this.getDirectory(urlParts.stateTaskId, projectTaskId)

            //Get purchase item if task
            await this.getPurchaseItem(urlParts.stateTask, purchaseId)
          }

          this.$refs.purchaseProjectTaskRequest.open()

        }catch (err){
          console.log(err)
        }
      },
      // open modal purchases
      async openModalEdit(companyId, projectId, projectTaskId, purchaseId, state, manager){
        this.activePurchaseId = purchaseId
        this.disabledInputs = false
        console.log('companyId, projectId, purchaseId, state, manager', companyId, 'projectId', projectId, 'projectTaskId', projectTaskId, purchaseId, state, manager)
        try {
          const urlParts = this.buildUrl(state)
          this.labelName = urlParts.labelName
          this.state = state

          //Get project list
          // this.projectList = await this.getProjectList(urlParts.routeName)

          //Get task list

            if(projectTaskId){
                this.action = 'editTask'
                // Get directories if task
                await this.getDirectory(urlParts.stateTaskId, projectTaskId)

                //Get purchase item if task
                await this.getPurchaseItem(urlParts.stateTask, purchaseId)
            }else if(projectId){
                this.action = 'editProject'
                // this.taskList = await this.getTaskList(projectId)

                // Get directories if project
                await this.getDirectory(urlParts.stateProjectId, projectId)

                //Get purchase item if project
                await this.getPurchaseItem(state, purchaseId)
            }

          this.$refs.purchaseProjectTaskRequest.open()

        }catch (err){
          console.log(err)
        }
      },
      getProjectList(routeName){
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${routeName}/list?companyId=${this.$route.query.companyId}`)
            .then(response => {
                resolve(response.data.list)
            }).catch(error =>{
                console.log(error)
                reject(error)
          })
        })
      },
      async handleSelectProject(item){
        if(this.selectedProject.id !== item.id) {
          this.resetForm(true)
        }
        this.selectedProject = item
        let loader = this.$loading.show()
        console.log('selected project', item)
        const urlParts = this.buildUrl(this.state)
        // get task list
        this.taskList = await this.getTaskList(item.id)
        //get project directories
        await this.getDirectory(urlParts.stateProjectId, item.id)

        this.disabledInputs = false
        loader.hide()
      },
      async handleSelectTask(item){
        if(this.selectedTask.id !== item.id) {
            this.resetForm(false)
        }
        this.selectedTask = item
        let loader = this.$loading.show()
        const urlParts = this.buildUrl(this.state)

        //get task directories
        await this.getDirectory(urlParts.stateTaskId, item.id)
        loader.hide()
      },
      checkNum(rule, value, callback){
        setTimeout(() => {
          if (value == 0) {
            return callback(new Error('Qty cant be 0'));
          }else{
            callback()
          }
        }, 500)
      },
      getTaskList(projectId){
        const urlParts = this.buildUrl(this.state)
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${urlParts.stateProjectTasks}/list?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}`)
            .then(response => {
              console.log('response', response)
              resolve(response.data.list)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        })
      },
      getDirectory(stateProjectId, id){
        return new Promise((resolve, reject) =>{
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/purchaseRequest/directory?companyId=${this.$route.query.companyId}&${stateProjectId}=${id}`)
            .then(response => {
              console.log('response', response)
              const myVendorList = []
              //TODO
              if(stateProjectId === 'projectId'){
                response.data.vendorList.forEach(val =>{
                  myVendorList.push(val.companyVendor)
                })
              }else{
                response.data.vendorList.forEach(val =>{
                  myVendorList.push(val.companyVendorPerson.companyVendor)
                })
              }
              this.taxList = response.data.projectTaxList
              this.vendorList = myVendorList
              resolve(response.data.vendorList)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        })
      },
      getPurchaseItem(type, purchaseId){
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/purchaseRequest/item?type=${type}&id=${purchaseId}`)
            .then(response => {
              this.form.vendorId = response.data.item.purchaseRequest.vendorId,
              this.form.date = response.data.item.purchaseRequest.orderDate * 1000,
              this.form.vendorCurrency = response.data.item.purchaseRequest.vendorCurrency,
              this.form.vendorCredit = response.data.item.purchaseRequest.vendorCredit,
              this.form.exchageRate = response.data.item.purchaseRequest.exchageRate,
              this.form.reference = response.data.item.purchaseRequest.reference,
              this.form.deliverTo = response.data.item.purchaseRequest.deliverTo,
              this.form.itemsId = response.data.item.purchaseRequest.items.map(item => item.id)
              this.form.ifTax = response.data.item.purchaseRequest.includeTax ? 'Tax Exclusive' : 'Tax Inclusive',
              this.form.isWth = response.data.item.purchaseRequest.inludeWth,
              this.form.description = response.data.item.purchaseRequest.description,
              //bill
              this.form.subTotal = response.data.item.purchaseRequest.subTotal,
              this.form.taxOf = response.data.item.purchaseRequest.taxOf,
              this.form.totalAmount = response.data.item.purchaseRequest.totalAmount,
              this.form.includesTaxOf = response.data.item.purchaseRequest.includeTax,
              this.form.whtTaxAmount = response.data.item.purchaseRequest.whtTaxAmount,
              this.form.paymentToVendor = response.data.item.purchaseRequest.paymentToVendor

              switch(type){
                case 'project':
                  this.form.projectId = response.data.item.project.id
                  this.projectList = [response.data.item.project]
                break;
                case 'projectTask':
                    this.form.taskId = response.data.item.projectTask.id
                    this.taskList = [response.data.item.projectTask]
                break;
                case 'engagement':
                  this.form.projectId = response.data.item.engagament.id
                  this.projectList = [response.data.item.engagament]
                break;
                case 'engagementTask':
                  this.form.taskId = response.data.item.engagamentTask.id
                  this.taskList = [response.data.item.engagamentTask]
                break;
                case 'businessUnit':
                  this.form.projectId = response.data.item.businessUnit.id
                  this.projectList = [response.data.item.businessUnit]
                  break;
                case 'businessUnitTask':
                  this.form.taskId = response.data.item.businessUnitTask.id
                  this.taskList = [response.data.item.businessUnitask]
                break;
              }

              // create item list
              const items = []
              response.data.item.purchaseRequest.items.forEach(val => {
                const item = {
                  id: val.id,
                  originalItemId: val.originalItemId,
                  code: val.code,
                  name: val.name,
                  tax: val.tax,
                  unit: val.unit,
                  wtx: val.withholdingTax,
                  amount: val.amount,
                  taxId: val.taxId,
                  itemWhTaxName: val.withholdingTax ? val.withholdingTax.name : null,
                  qty: val.qty,
                  date: val.date * 1000,
                  vatExclusive: val.vatExclusive,
                  total: val.total,
                }
                items.push(item)
              })

              this.form.items = items
              this.selectedVendor.items = response.data.item.purchaseRequest.items



                resolve(response.data.item)
            }).catch(error =>{
            console.log(error)
            reject(error)
          })
        })
      },
      resetForm(isProj) {
        if(this.form.items.length !== 0){
          this.form.items = []
          this.form.itemsId = []
          this.form.vendorId = ''
        }else if(!this.form.items.length) {
          this.form.vendorId = ''
        }
        if(isProj){
          this.form.taskId = ''
        }
      },
      setItemToRequest(item){
        const addedItem = { id: item.id,
          code: item.number,
          name: item.name,
          amount:item.buyPrice || null,
          unit: item.unit,
          taxId: item.buyerProjectTax ? item.buyerProjectTax.id : null,
          itemWhTaxName: item.buyerWithholdingTax ? item.buyerWithholdingTax.name : null,
          qty: 1,
          date: null,

          //надо считать читает dom
          vatExclusive: '',
          total: '',

          tax:item.buyerProjectTax,
          wtx:item.buyerWithholdingTax}
        for (let i = 0; i < this.form.items.length; i++){
          if(this.form.items[i].id === item.id){
            this.form.items.splice(i, 1)
            return
          }
        }
        this.form.items.push(addedItem)
      },
      removeTag(id){
        for (let i = 0; i < this.form.items.length; i++){
          if(this.form.items[i].id === id){
            this.form.items.splice(i, 1)
            return
          }
        }
        },
      //COUNT VAT EXCLUSIVE COLUMN
      countVatExclusive(amount, qty, tax, ifTax){
        console.log('amount, qty, tax, ifTax', amount, qty, tax, ifTax)
        //if no qty or amount
        if(!amount || amount === 0 || !qty && qty === 0){
          return 0
        }
        let percentages = ''
        switch(ifTax){
          case 'Tax Inclusive':
            //check if tax = 0
            if(!tax || tax.value === 0){
              return amount * qty
            }
            percentages = tax.value
            if(percentages.toString().length < 2){
              percentages = '1.0' + percentages.toString()
              console.log('1.0...', Number(percentages))
            }else{
              percentages = '1.' + percentages.toString()
              console.log('1.', Number(percentages))
            }
            return (amount * qty) / Number(percentages)
          case 'Tax Exclusive':
            return amount * qty
        }
        // if(ifTax === 'Tax Inclusive'){
        //   return amount / 2
        // }else{
        //   return amount * 2
        // }
      },
      //COUNT TOTAL AMOUNT EXCLUSIVE COLUMN
      countTotalAmount(amount, qty, tax, ifTax){
        //if no qty or amount
        if(!amount || amount === 0 || !qty && qty === 0){
          return 0
        }
        switch(ifTax){
          case 'Tax Inclusive':
            //check if tax = 0
            if(!tax || tax.value === 0){
              return amount * qty
            }else{
              return amount * qty
            }
          case 'Tax Exclusive':
            //check if tax = 0
            if(!tax || tax.value === 0) {
              return amount * qty
            }else{
              return (amount * qty) + (amount * qty) / 100 * tax.value
            }
        }
      },
      //COUNT SUBTOTAL
      countSubtotal(items){
        // console.log('subtotals', items)
        const results = []
        for (let i = 0; i < items.length; i++) {
          if(!items[i].amount || !items[i].qty || items[i].amount === 0 || items[i].qty === 0){
            results.push(0)
          }else{
            results.push(items[i].amount * items[i].qty)
          }
        }

        if (results.length === 0) {
          return 0
        }else{
          const result = results.reduce(function(sum, current) {
            return sum + current
          });

          // console.log('results', results)
          // console.log('result', result)
          return result
        }
      },
      //COUNT TAX OF
      countTaxOf(items){
        // console.log('taxofs', items)
        const results = []
        for (let i = 0; i < items.length; i++) {
          if(!items[i].vatExclusive || !items[i].tax || !items[i].tax === {}) {
            results.push(0)
          }else if (items[i].tax.value === 0) {
            results.push(0)
          }else {
            console.log('Number(items[i].vatExclusive)', Number(items[i].vatExclusive))
            results.push((Number(items[i].vatExclusive)/100)*Number(items[i].tax.value))
          }
        }

        if (results.length === 0) {
          return 0
        }else {
          const result = results.reduce(function (sum, current) {
            return sum + current
          });

          // console.log('results', results)
          // console.log('result', result)
          return result
        }

      },
      //COUNT SUM OF TOTAL AMOUNT
      countSumTotalAmount(items){
        const results = []
        for (let i = 0; i < items.length; i++) {
          results.push(items[i].total)
        }

        if (results.length === 0) {
          return 0
        }else {
          const result = results.reduce(function (sum, current) {
            return sum + current
          });

          // console.log('results', results)
          // console.log('result', result)
          return result
        }
      },
      //COUNT WHTAmount
      countWhtTaxAmount(items){
        // console.log('countWhtTaxAmount', items)
        const results = []

        for (let i = 0; i < items.length; i++) {
          if(!items[i].vatExclusive || !items[i].wtx || items[i].wtx === {} || items[i].wtx.value === 0){
            results.push(0)
          }else {
            results.push(items[i].vatExclusive / 100 * items[i].wtx.value)
          }
        }

        if (results.length === 0) {
          return 0
        }else {
          const result = results.reduce(function (sum, current) {
            return sum + current
          });

          // console.log('results', results)
          // console.log('result', result)
          return result
        }

      },
      //COUNT INCLUDES TAX OF
      countIncludesTaxOf(items){
        console.log('countIncludesTaxOf', items)
        const results = []

        for (let i = 0; i < items.length; i++) {
          if(!items[i].total || !items[i].total === 0 || !items[i].tax || items[i].tax.value === 0){
            results.push(0)
          }else{
            let percentages = ''
            percentages = items[i].tax.value
            if(percentages.toString().length < 2){
              percentages = '1.0' + percentages.toString()
              console.log('1.0...', Number(percentages))
            }else{
              percentages = '1.' + percentages.toString()
              console.log('1.', Number(percentages))
            }
            results.push(items[i].total - items[i].total / Number(percentages))
          }
        }

        if (results.length === 0) {
          return 0
        }else {
          const result = results.reduce(function (sum, current) {
            return sum + current
          });

          console.log('results', results)
          console.log('result', result)
          return result
        }

      },
      //COUNT PAYMENT TO VENDOR
      countPaymentToVendor(totalAmount, whtTaxAmount, ifWth){
        if(ifWth){
          return totalAmount - whtTaxAmount
        }else{
          return totalAmount
        }
      },
      countModal(row, tax){
        row.tax = tax
        console.log('hello', row.tax)
      },
      countModalFull(){
        console.log('count full modal')
      },
      handleSelectVendor(vendor){
        this.disabledInputs = false
        if(this.selectedVendor.id !== vendor.id){
          this.form.items = []
          this.form.itemsId = []
        }
        this.selectedVendor = vendor
        this.itemsList = vendor.items
        console.log('vendor', vendor)
      },
      closePurchaseProjectTaskRequest(){
        // this.form.projectId = ''
        // this.form.taskId = ''
        // this.form.vendorId = ''
        // this.form.date = null
        // this.form.vendorCurrency = 'GBP'
        // this.form.vendorCredit = '0'
        // this.form.exchageRate = null
        // this.form.reference = null
        // this.form.deliverTo = null
        // this.form.ifTax = 'Tax Exclusive'
        // this.form.isWth = false
        // this.form.description = null
        // this.form.itemsId = []
        this.form.items = []
        //bill
        this.form.subTotal = '0'
        this.form.taxOf = '0'
        this.form.totalAmount ='0'
        this.form.includesTaxOf = '0'
        this.form.whtTaxAmount = '0'
        this.form.paymentToVendor = '0'
        this.$refs['form'].resetFields();
        this.form.allowPartialDeliveries = false
        this.form.sendInventoryWithBill = false
        this.form.sendInventoryWithoutBill = false
        this.form.receiveReportRequired = false
        this.form.inspectionReportRequired = false
        this.disabledInputs = true
      },
      purchaseSubmit(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            const urlParts = this.buildUrl(this.state)
            if(this.form.items.length === 0) {
              return this.$message({
                type: 'error',
                message: 'Select items'
              })
            }

            const data = {
              vendorId: this.form.vendorId,
              orderDate: this.form.date / 1000,
              vendorCurrency: this.form.vendorCurrency,
              vendorCredit: this.form.vendorCredit,
              exchageRate: Number(this.form.exchageRate),
              reference: this.form.reference,
              deliverTo: this.form.deliverTo,
              includeTax: this.form.ifTax === 'Tax Exclusive',
              inludeWth: this.form.isWth,
              description: this.form.description,
              //bill
              subTotal: this.form.ifTax === 'Tax Exclusive' ? this.form.subTotal : null,
              taxOf: this.form.ifTax === 'Tax Exclusive' ? this.form.taxOf : null,
              totalAmount: this.form.totalAmount,
              includesTaxOf: this.form.ifTax === 'Tax Inclusive' ? this.form.includesTaxOf : null,
              whtTaxAmount: this.form.isWth ? this.form.whtTaxAmount : null,
              paymentToVendor: this.form.paymentToVendor,
              // checkboxes
              allowPartialDeliveries: this.form.allowPartialDeliveries,
              sendInventoryWithBill: this.form.sendInventoryWithBill,
              sendInventoryWithoutBill: this.form.sendInventoryWithoutBill,
              receiveReportRequired: this.form.receiveReportRequired,
              inspectionReportRequired: this.form.inspectionReportRequired,
            }

            const items = []
            this.form.items.forEach(val => {
              const item = {
                originalItemId: val.id,
                code: val.code,
                name: val.name,
                amount: val.amount,
                unitId: val.unit.id,
                taxId: val.taxId,
                itemWhTaxId: val.wtx ? val.wtx.id : null,
                qty: val.qty,
                date: val.date / 1000,
                vatExclusive: val.vatExclusive,
                total: val.total,
              }
              items.push(item)
            })
            data.items = items
            return new Promise((resolve, reject) =>{
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post(`/api/v1/purchaseRequest/create?type=${this.state}&companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${this.form.projectId}&${urlParts.stateTaskId}=${this.form.taskId ? this.form.taskId : null }`, data)
                .then(response => {
                  this.notification("Success", "Request Created", "success")
                  this.$emit('setValueProject', this.form.projectListId);
                  this.$refs.purchaseProjectTaskRequest.close()
                  // this.closePurchaseProjectTaskRequest()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  reject(error)
                });
            })
          }
        })
      },
      purchaseApprove(form, id){
        this.$refs[form].validate((valid) => {
          if (valid) {
            const urlParts = this.buildUrl(this.state)
            if(this.form.items.length === 0) {
              return this.$message({
                type: 'error',
                message: 'Select items'
              })
            }

            const data = {
              vendorId: this.form.vendorId,
              orderDate: this.form.date / 1000,
              vendorCurrency: this.form.vendorCurrency,
              vendorCredit: this.form.vendorCredit,
              exchageRate: Number(this.form.exchageRate),
              reference: this.form.reference,
              deliverTo: this.form.deliverTo,
              includeTax: this.form.ifTax === 'Tax Exclusive',
              inludeWth: this.form.isWth,
              description: this.form.description,
              //bill
              subTotal: this.form.ifTax === 'Tax Exclusive' ? this.form.subTotal : null,
              taxOf: this.form.ifTax === 'Tax Exclusive' ? this.form.taxOf : null,
              totalAmount: this.form.totalAmount,
              includesTaxOf: this.form.ifTax === 'Tax Inclusive' ? this.form.includesTaxOf : null,
              whtTaxAmount: this.form.isWth ? this.form.whtTaxAmount : null,
              paymentToVendor: this.form.paymentToVendor
            }

            const items = []
            this.form.items.forEach(val => {
              const item = {
                id: val.id,
                code: val.code,
                name: val.name,
                amount: val.amount,
                unitId: val.unit.id,
                taxId: val.taxId,
                itemWhTaxId: val.wtx ? val.wtx.id : null,
                qty: val.qty,
                date: val.date / 1000,
                vatExclusive: val.vatExclusive,
                total: val.total,
              }
              items.push(item)
            });
            data.items = items
            return new Promise((resolve, reject) =>{
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post(`/api/v1/purchaseRequest/approve?id=${id}`, data)
                .then(response => {
                  this.notification("Success", "Request Approved", "success")
                  if(this.$route.name === 'projects' && this.state === 'project' || this.$route.name === 'business-units' && this.state === 'business-unit' || this.$route.name === 'engagements' && this.state === 'engagement' || this.$route.name === 'purchases') {
                    this.$emit('refreshPurchase')
                  }
                  this.$refs.purchaseProjectTaskRequest.close()
                  // this.closePurchaseProjectTaskRequest()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  reject(error)
                });
            })
          }
        })
      },
      purchaseReject(form, id){
        return new Promise((resolve, reject) =>{
            const data = {
                description: this.description
            };
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/purchaseRequest/reject?id=${id}`, data)
            .then(response => {
              this.notification("Success", "Request Rejected", "success")
              if(this.$route.name === 'projects' && this.state === 'project' || this.$route.name === 'business-units' && this.state === 'business-unit' || this.$route.name === 'engagements' && this.state === 'engagement' || this.$route.name === 'purchases') {
                this.$emit('refreshPurchase')
              }
              this.description = ''
                this.$refs.rejectConfirm.close()
                this.$refs.purchaseProjectTaskRequest.close()
              // this.closePurchaseProjectTaskRequest()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        })
      },
      purchaseEdit(form, id){
        this.$refs[form].validate((valid) => {
          if (valid) {
            const urlParts = this.buildUrl(this.state)
            if(this.form.items.length === 0) {
              return this.$message({
                type: 'error',
                message: 'Select items'
              })
            }

            const data = {
              vendorId: this.form.vendorId,
              orderDate: this.form.date / 1000,
              vendorCurrency: this.form.vendorCurrency,
              vendorCredit: this.form.vendorCredit,
              exchageRate: Number(this.form.exchageRate),
              reference: this.form.reference,
              deliverTo: this.form.deliverTo,
              includeTax: this.form.ifTax === 'Tax Exclusive',
              inludeWth: this.form.isWth,
              description: this.form.description,
              //bill
              subTotal: this.form.ifTax === 'Tax Exclusive' ? this.form.subTotal : null,
              taxOf: this.form.ifTax === 'Tax Exclusive' ? this.form.taxOf : null,
              totalAmount: this.form.totalAmount,
              includesTaxOf: this.form.ifTax === 'Tax Inclusive' ? this.form.includesTaxOf : null,
              whtTaxAmount: this.form.isWth ? this.form.whtTaxAmount : null,
              paymentToVendor: this.form.paymentToVendor
            }

            const items = []
            this.form.items.forEach(val => {
              const item = {
                id: val.id,
                code: val.code,
                name: val.name,
                amount: val.amount,
                unitId: val.unit.id,
                taxId: val.taxId,
                itemWhTaxId: val.wtx ? val.wtx.id : null,
                qty: val.qty,
                date: val.date / 1000,
                vatExclusive: val.vatExclusive,
                total: val.total,
              }
              items.push(item)
            })
            data.items = items
            return new Promise((resolve, reject) =>{
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post(`/api/v1/purchaseRequest/update?id=${id}`, data)
                .then(response => {
                  this.notification("Success", "Request Updated", "success")
                  if(this.$route.name === 'projects' && this.state === 'project' || this.$route.name === 'business-units' && this.state === 'business-unit' || this.$route.name === 'engagements' && this.state === 'engagement') {
                    this.$emit('refreshPurchase')
                  }else if (this.$route.name === 'purchases'){
                    this.$emit('setValueProject', this.form.projectListId);
                  }
                  this.$refs.purchaseProjectTaskRequest.close()
                  this.closePurchaseProjectTaskRequest()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  reject(error)
                });
            })
          }
        })
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      cellClick(row, column, event){
        console.log('row', row)
        console.log('column', column)
      },
      rejectConfirmClose(){
        this.description = ''
      },
      buildUrl(state) {
        let routeName = ''
        let labelName = ''
        let stateProjectId = ''
        let projectId = ''
        let stateTaskId = ''
        let taskId = ''
        let stateExpenseId = ''
        let stateProjectTasks = ''
        let stateTask = ''
        switch (state){
          case 'project':
            routeName = 'projects'
            labelName = 'Project'
            stateProjectId = 'projectId'
            stateProjectTasks = 'projectTasks'
            stateTaskId = 'projectTaskId'
            stateExpenseId = 'projectTaskPurchaseId'
            stateTask = 'projectTask'
            break;
          case 'engagement':
            routeName = 'engagements'
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTasks = 'engagementTasks'
            stateExpenseId = 'engagementTaskPurchaseId'
            labelName = 'Engagement'
            stateTask = 'engagementTask'
            break;
          case 'businessUnit':
            routeName = 'businessUnits'
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTasks = 'businessUnitTasks'
            stateExpenseId = 'businessUnitTaskPurchaseId'
            labelName = 'Business Unit'
            stateTask = 'businessUnitTask'
            break;
        }
        return {
          state: state,
          routeName: routeName,
          stateProjectId: stateProjectId,
          labelName: labelName,
          projectId: projectId,
          stateTaskId: stateTaskId,
          stateProjectTasks: stateProjectTasks,
          taskId: taskId,
          stateExpenseId: stateExpenseId,
          stateTask: stateTask }
      }
    }
  }
</script>

<style lang="less" scoped>
    /deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
        width:100%;
    }
    /deep/.sweet-modal-overlay{
        z-index:1000;
        .sweet-modal {
            max-width: 100% !important;
        }
    }
    .bill{
        text-align:right;
        h4{
            line-height:0.6;
            span{
                padding: 0 10px;
            }
        }
        .payment-to-vendor{
            background: rgb(227, 228, 230);
            h3{
                span{
                    padding: 0 10px;
                }
            }
        }
    }
    .nested-confirm{
        .modal__bottom{
            margin-top:20px;
        }
    }
</style>
